import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '@hook/common/useStore';
import { LOCAL_STORAGE_ACCESS_TOKEN_KEY } from '@config/auth';
import { ADMIN_PATH } from '@constant/admin/route-path';
import { EUserRole } from '@datatype/type';

interface IProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<IProps> = ({ children }) => {
  const navigate = useNavigate();
  const role = useTypedSelector((state) => state.rootReducer?.userReducer?.role) ?? null;
  const isAuthenticated = useTypedSelector((state) => state.rootReducer?.userReducer?.isAuthenticated) ?? false;

  useEffect(() => {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    if (!accessToken || !isAuthenticated) {
      navigate(ADMIN_PATH.SIGNIN_PATH, { replace: true });
      return;
    }
    if (role !== EUserRole.ADMIN) {
      navigate(ADMIN_PATH.SIGNIN_PATH, { replace: true });
    }
  }, [isAuthenticated, role, navigate]);

  if (!isAuthenticated || role !== EUserRole.ADMIN) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;
